import React from "react";

const ItemConditionToggle = ({ value, onChange }) => {
  const options = ["NEW", "USED"];

  return (
    <div className="mt-6">
      <label className="block mb-2 text-sm font-semibold text-zinc-300">
        Item Condition
      </label>
      <div className="flex space-x-3">
        {options.map((option) => (
          <button
            key={option}
            className={`px-4 py-2 rounded-full border text-sm font-medium transition-all
              ${
                value === option
                  ? "bg-blue-600 text-white border-blue-600 shadow"
                  : "bg-zinc-800 text-zinc-300 border-zinc-600 hover:bg-zinc-700"
              }`}
            onClick={() => onChange(option)}
            type="button"
          >
            {option}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ItemConditionToggle;
